// removed by extract-text-webpack-plugin
module.exports = {"block":"Button__block-2pWEN"};